import { useSelector } from 'react-redux';
import { addHowItWorksData, getHowItWorksDataSelector } from '../Redux/appStateSlice';
import { WithFetchJsonContent } from './WithFetchJsonContent';

export const WithHowItWorks = ({ children }) => {
  const howItWorksData = useSelector(getHowItWorksDataSelector);

  return (
    <WithFetchJsonContent
      reduxInStore={howItWorksData}
      addToReduxFunction={addHowItWorksData}
      jsonLocation="content/HIW"
    >
      {children}
    </WithFetchJsonContent>
  );
};
